import Component from '@ember/component';
import { action, computed, get, set } from '@ember/object';
import { isEmpty, isPresent } from '@ember/utils';

/*
  attrs
  - changeset
  - property
  - label
  - hideLabel - boolean - default false
  - showValidationErrors
  - selectOptions
    - array of { label: '', val: '' } for select options
  - stringSelectOptions
    - array of strings for select options
  - placeholder
  - onChange(value) - action fired when select is changed
*/

export default Component.extend({
  classNames: ['form-group'],
  classNameBindings: ['hasErrors'],

  changeset: null,
  property: null,
  label: null,
  showValidationErrors: null,
  focusOnInsert: false,
  selectOptions: null,
  placeholder: undefined,
  options: computed('selectOptions', 'stringSelectOptions', function () {
    if (isPresent(this.selectOptions)) {
      return this.selectOptions;
    } else if (isPresent(this.stringSelectOptions)) {
      return this.stringSelectOptions.map((option) => {
        return { label: option, val: option };
      });
    } else {
      return null;
    }
  }),

  changesetPropertyVal: '',
  selectedOption: computed('changesetPropertyVal', function () {
    let changesetPropertyVal = this.changesetPropertyVal;
    return this.options.find((x) => get(x, 'val') === changesetPropertyVal);
  }),

  hasErrors: computed(
    'showValidationErrors',
    'changeset.errors.[]',
    'property',
    function () {
      if (this.showValidationErrors === false) {
        return false;
      }
      let property = this.property;
      return (
        get(this, 'changeset.errors').find(function (item) {
          return get(item, 'key') === property;
        }) != null
      );
    },
  ),

  didInsertElement: function () {
    this._super(...arguments);
    set(this, 'changesetPropertyVal', get(this, `changeset.${this.property}`));
  },

  focusComesFromOutside(e) {
    if (e.target.classList.contains('ember-basic-dropdown-trigger--below')) {
      return false;
    }
    let blurredEl = e.relatedTarget;
    return (
      isEmpty(blurredEl) ||
      !blurredEl.classList.contains('ember-power-select-search-input')
    );
  },

  handleFocused: action(function (select, e) {
    if (!e.target.classList.contains('ember-power-select-trigger')) {
      return;
    }
    if (this.focusComesFromOutside(e)) {
      setTimeout(() => {
        select.actions.open();
      }, 0);
    }
  }),

  handleChanged: action(function (option) {
    let val = get(option, 'val');
    set(this, `changeset.${this.property}`, val);
    set(this, 'changesetPropertyVal', val);
    if (this.onChange) {
      this.onChange(val);
    }
  }),
});
